var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermstechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.96 60.8301L15 92.4201H34.96V84.4001V60.8301Z",
    fill: "#D6AE68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5401 16.4H78.7901L84.0401 8H65.8601L60.55 16.4H65.19H78.5401Z",
    fill: "#D6AE68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8401 20.4004C55.3201 21.9404 57.5301 23.8904 59.3801 26.1604C61.1701 28.3704 62.6401 30.8704 63.6501 33.6304C63.6901 33.7404 63.7301 33.8404 63.7601 33.9504L63.7901 34.0404C63.9301 34.4504 64.0701 34.8704 64.1901 35.3004C64.9001 37.7104 65.2601 40.2104 65.2601 42.7104H83.5301V20.4004H52.8301H52.8401Z",
    fill: "#7C2529"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9701 46.6904L61.1401 42.5204C61.1501 42.1604 61.3401 35.8704 57.0401 29.8604C55.5001 27.7104 53.4001 25.6004 50.5001 23.8004L48.4901 22.5504C45.6001 21.1804 42.3601 20.4004 38.9501 20.4004H16.6401V42.7104H38.9501V88.4004H61.2601V46.6904H60.9601H60.9701Z",
    fill: "#250201"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.05 34.8598L57.11 34.7598C54.91 31.6798 51.95 29.1898 48.5 27.5498L50.51 28.7998C53.41 30.5998 55.51 32.7098 57.05 34.8598Z",
    fill: "#250201"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2701 47.7098C61.2701 45.5298 60.9501 43.4198 60.3701 41.4198C60.2601 41.0598 60.1501 40.7098 60.0301 40.3598C59.9901 40.2398 59.9501 40.1298 59.9101 40.0098C59.2201 38.1298 58.2601 36.3698 57.1201 34.7598L57.0601 34.8598C61.3601 40.8698 61.1701 47.1598 61.1601 47.5198L60.9901 51.6898H61.2901V47.7098H61.2701Z",
    fill: "#250201"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermstechIcon);
export default __webpack_public_path__ + "static/media/termstech-icon.4884629db950f9f9951a9e10c994d021.svg";
export { ForwardRef as ReactComponent };